import * as React from 'react';

import './steps.css';

import { StepMarkerType, StepItemProps } from '../../types';

class StepItem extends React.Component<StepItemProps, any> {
  private regularMarker = (
    <div className="step-marker">{this.props.stepId}</div>
  );

  // Marker for completed step item
  private completedMarker = (
    <div className="step-marker">
      <span className="icon">
        <i className="fas fa-check" />
      </span>
    </div>
  );

  // Marker for final goal item
  private goalMarker = (
    <div className="step-marker">
      <span className="icon">
        <i className="fas fa-flag" />
      </span>
    </div>
  );

  public constructor(props: StepItemProps) {
    super(props);
  }

  public render() {
    let completedClass = '';
    let stepMarker = this.regularMarker;
    switch (this.props.markerType) {
      case StepMarkerType.COMPLETED:
        stepMarker = this.completedMarker;
        completedClass = 'is-completed';
        break;
      case StepMarkerType.GOAL:
        stepMarker = this.goalMarker;
        break;
    }

    const activeClass = this.props.isActive ? 'is-active' : '';
    return (
      <div className={`step-item ${activeClass} ${completedClass}`.trim()}>
        {stepMarker}
        <div className="step-details">
          <p className="step-title">{this.props.stepTitle}</p>
          <p>{this.props.children}</p>
        </div>
      </div>
    );
  }
}

export default StepItem;



// WEBPACK FOOTER //
// ./src/common/steps/StepItem.tsx